var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mb-5 text-3xl font-bold"},[_vm._v(_vm._s(_vm.$t("title.privacyPolicy")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }